// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Ms_Ggi {
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: column;
}

.sdnzDp,
.k8XcVc {
  display: grid;
  grid-template-columns: minmax(140px, 1.6fr) 1.1fr 1.4fr 1.1fr 1.5fr 1fr 1.4fr 56px;
  align-items: center;
  gap: 16px;
  padding: 8px 24px;
  min-height: 49px;
}

.ynmXnh {
  font-family: var(--font-family-base);
  font-size: 14px;
  font-weight: var(--font-weight-medium, 500);
  line-height: var(--line-height-160);
  color: var(--text-neutral-dark, #1f1f1f);
}

.sdS96m {
  display: flex;
  flex-direction: column;
}

.k8XcVc {
  background-color: var(--surface-neutral-white, #ffffff);
  border-radius: var(--radius-s, 4px);
}

.tuBOlh {
  display: grid;
  grid-column: span 6;
  grid-template-columns: minmax(140px, 1.6fr) 1.1fr 1.4fr 1.1fr 1.5fr 1fr;
  align-items: center;
  gap: 16px;
  min-width: 0;
  padding: 0;
  color: inherit;
  font: inherit;
  text-align: left;
  background: transparent;
  border: 0;
}

.tuBOlh:not(:disabled) {
  cursor: pointer;
}

.tuBOlh:focus-visible {
  outline: 2px solid var(--border-interactive-focus, #005da9);
  outline-offset: 2px;
}

.k8XcVc:nth-child(odd) {
  background-color: #fafafa;
}

.qZWu6X,
.QHQZvj,
.uvdpn1 {
  font-family: var(--font-family-base);
  font-size: 14px;
  font-weight: var(--font-weight-regular, 400);
  line-height: var(--line-height-160);
  color: var(--text-neutral-dark, #1f1f1f);
}

.QHQZvj {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.KzP9j_ {
  display: flex;
  align-items: center;
  justify-content: flex-start;
}

.fAZycL {
  position: relative;
  display: flex;
  align-items: center;
  gap: var(--spacing-1, 8px);
  font-family: var(--font-family-base);
  font-size: 14px;
  font-weight: var(--font-weight-regular, 400);
  line-height: var(--line-height-160);
  color: var(--text-neutral-dark, #1f1f1f);
}

.UC809y {
  padding: 0;
}

.bxfUdA {
  top: 28px !important;
  bottom: auto !important;
}

.GMc9iX {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: var(--spacing-4-5) var(--spacing-3);
  text-align: center;
}

.lYQRTi {
  margin-top: var(--spacing-2);
  font-size: var(--font-size-sm);
  color: var(--text-neutral-strong);
}

@media (max-width: 1023px) {
  .sdnzDp {
    display: none;
  }

  .k8XcVc {
    grid-template-columns: 1fr auto;
    row-gap: var(--spacing-1);
    column-gap: var(--spacing-2);
  }

  .tuBOlh {
    grid-column: 1;
    grid-row: 1 / span 6;
    grid-template-columns: 1fr;
    gap: var(--spacing-1);
  }

  .fAZycL {
    grid-column: 1;
    grid-row: 7;
  }

  .KzP9j_ {
    grid-row: 1 / span 7;
    grid-column: 2;
  }
}

.TdhFSk .sdnzDp,
.TdhFSk .k8XcVc {
  grid-template-columns:
    minmax(0, 140.355fr) minmax(0, 108.537fr) minmax(0, 143.977fr) minmax(0, 112.765fr) minmax(0, 161fr)
    minmax(0, 95.592fr) minmax(0, 165fr) minmax(0, 24.774fr);
  height: 49px;
  box-sizing: border-box;
}

.TdhFSk .tuBOlh {
  grid-template-columns: subgrid;
}

.TdhFSk .sdnzDp {
  column-gap: 0;
  grid-template-columns:
    minmax(0, 155.877fr) minmax(0, 125.567fr) minmax(0, 158.644fr) minmax(0, 129.299fr) minmax(0, 177.705fr)
    minmax(0, 111.953fr) minmax(0, 169.853fr) minmax(0, 35.102fr);
}

.TdhFSk .ynmXnh {
  font-weight: 400;
  line-height: normal;
}

.TdhFSk::before {
  content: '';
  position: absolute;
  top: -1px;
  left: 0;
  width: 100%;
  height: 1px;
  background: #e6e6e6;
  pointer-events: none;
}

.TdhFSk .qZWu6X,
.TdhFSk .QHQZvj,
.TdhFSk .uvdpn1,
.TdhFSk .fAZycL {
  line-height: normal;
}

.TdhFSk .UC809y {
  width: 24px;
  height: 24px;
  min-width: 24px;
  padding: 0;
  border: none;
}

.TdhFSk .fAZycL {
  gap: 0;
}

.TdhFSk .qZWu6X [data-testid\$='Status'] {
  height: 20px;
  box-sizing: border-box;
  line-height: normal;
}

.TdhFSk .KzP9j_ {
  justify-content: center;
}
`, "",{"version":3,"sources":["webpack://./../../packages/beneficios/src/components/EmissorOrderList/EmissorOrderList.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,sBAAsB;AACxB;;AAEA;;EAEE,aAAa;EACb,kFAAkF;EAClF,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;EACpC,eAAe;EACf,2CAA2C;EAC3C,mCAAmC;EACnC,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,uDAAuD;EACvD,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uEAAuE;EACvE,mBAAmB;EACnB,SAAS;EACT,YAAY;EACZ,UAAU;EACV,cAAc;EACd,aAAa;EACb,gBAAgB;EAChB,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,2DAA2D;EAC3D,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;;EAGE,oCAAoC;EACpC,eAAe;EACf,4CAA4C;EAC5C,mCAAmC;EACnC,wCAAwC;AAC1C;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,0BAA0B;EAC1B,oCAAoC;EACpC,eAAe;EACf,4CAA4C;EAC5C,mCAAmC;EACnC,wCAAwC;AAC1C;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,oBAAoB;EACpB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,4CAA4C;EAC5C,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;EAC5B,8BAA8B;EAC9B,iCAAiC;AACnC;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,+BAA+B;IAC/B,yBAAyB;IACzB,4BAA4B;EAC9B;;EAEA;IACE,cAAc;IACd,oBAAoB;IACpB,0BAA0B;IAC1B,qBAAqB;EACvB;;EAEA;IACE,cAAc;IACd,WAAW;EACb;;EAEA;IACE,oBAAoB;IACpB,cAAc;EAChB;AACF;;AAEA;;EAEE;;4DAE0D;EAC1D,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb;;iEAE+D;AACjE;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,WAAW;EACX,WAAW;EACX,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;;;;EAIE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,UAAU;EACV,YAAY;AACd;;AAEA;EACE,MAAM;AACR;;AAEA;EACE,YAAY;EACZ,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;AACzB","sourcesContent":[".container {\n  position: relative;\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n}\n\n.headerRow,\n.orderRow {\n  display: grid;\n  grid-template-columns: minmax(140px, 1.6fr) 1.1fr 1.4fr 1.1fr 1.5fr 1fr 1.4fr 56px;\n  align-items: center;\n  gap: 16px;\n  padding: 8px 24px;\n  min-height: 49px;\n}\n\n.headerCell {\n  font-family: var(--font-family-base);\n  font-size: 14px;\n  font-weight: var(--font-weight-medium, 500);\n  line-height: var(--line-height-160);\n  color: var(--text-neutral-dark, #1f1f1f);\n}\n\n.rowsList {\n  display: flex;\n  flex-direction: column;\n}\n\n.orderRow {\n  background-color: var(--surface-neutral-white, #ffffff);\n  border-radius: var(--radius-s, 4px);\n}\n\n.orderDetailsButton {\n  display: grid;\n  grid-column: span 6;\n  grid-template-columns: minmax(140px, 1.6fr) 1.1fr 1.4fr 1.1fr 1.5fr 1fr;\n  align-items: center;\n  gap: 16px;\n  min-width: 0;\n  padding: 0;\n  color: inherit;\n  font: inherit;\n  text-align: left;\n  background: transparent;\n  border: 0;\n}\n\n.orderDetailsButton:not(:disabled) {\n  cursor: pointer;\n}\n\n.orderDetailsButton:focus-visible {\n  outline: 2px solid var(--border-interactive-focus, #005da9);\n  outline-offset: 2px;\n}\n\n.orderRow:nth-child(odd) {\n  background-color: #fafafa;\n}\n\n.cell,\n.identification,\n.amount {\n  font-family: var(--font-family-base);\n  font-size: 14px;\n  font-weight: var(--font-weight-regular, 400);\n  line-height: var(--line-height-160);\n  color: var(--text-neutral-dark, #1f1f1f);\n}\n\n.identification {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.actionsCell {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n}\n\n.creditDateCell {\n  position: relative;\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-1, 8px);\n  font-family: var(--font-family-base);\n  font-size: 14px;\n  font-weight: var(--font-weight-regular, 400);\n  line-height: var(--line-height-160);\n  color: var(--text-neutral-dark, #1f1f1f);\n}\n\n.editCreditDateButton {\n  padding: 0;\n}\n\n.creditDateCalendar {\n  top: 28px !important;\n  bottom: auto !important;\n}\n\n.loadingContainer {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: var(--spacing-4-5) var(--spacing-3);\n  text-align: center;\n}\n\n.loadingText {\n  margin-top: var(--spacing-2);\n  font-size: var(--font-size-sm);\n  color: var(--text-neutral-strong);\n}\n\n@media (max-width: 1023px) {\n  .headerRow {\n    display: none;\n  }\n\n  .orderRow {\n    grid-template-columns: 1fr auto;\n    row-gap: var(--spacing-1);\n    column-gap: var(--spacing-2);\n  }\n\n  .orderDetailsButton {\n    grid-column: 1;\n    grid-row: 1 / span 6;\n    grid-template-columns: 1fr;\n    gap: var(--spacing-1);\n  }\n\n  .creditDateCell {\n    grid-column: 1;\n    grid-row: 7;\n  }\n\n  .actionsCell {\n    grid-row: 1 / span 7;\n    grid-column: 2;\n  }\n}\n\n.migrationPreview .headerRow,\n.migrationPreview .orderRow {\n  grid-template-columns:\n    minmax(0, 140.355fr) minmax(0, 108.537fr) minmax(0, 143.977fr) minmax(0, 112.765fr) minmax(0, 161fr)\n    minmax(0, 95.592fr) minmax(0, 165fr) minmax(0, 24.774fr);\n  height: 49px;\n  box-sizing: border-box;\n}\n\n.migrationPreview .orderDetailsButton {\n  grid-template-columns: subgrid;\n}\n\n.migrationPreview .headerRow {\n  column-gap: 0;\n  grid-template-columns:\n    minmax(0, 155.877fr) minmax(0, 125.567fr) minmax(0, 158.644fr) minmax(0, 129.299fr) minmax(0, 177.705fr)\n    minmax(0, 111.953fr) minmax(0, 169.853fr) minmax(0, 35.102fr);\n}\n\n.migrationPreview .headerCell {\n  font-weight: 400;\n  line-height: normal;\n}\n\n.migrationPreview::before {\n  content: '';\n  position: absolute;\n  top: -1px;\n  left: 0;\n  width: 100%;\n  height: 1px;\n  background: #e6e6e6;\n  pointer-events: none;\n}\n\n.migrationPreview .cell,\n.migrationPreview .identification,\n.migrationPreview .amount,\n.migrationPreview .creditDateCell {\n  line-height: normal;\n}\n\n.migrationPreview .editCreditDateButton {\n  width: 24px;\n  height: 24px;\n  min-width: 24px;\n  padding: 0;\n  border: none;\n}\n\n.migrationPreview .creditDateCell {\n  gap: 0;\n}\n\n.migrationPreview .cell :global([data-testid$='Status']) {\n  height: 20px;\n  box-sizing: border-box;\n  line-height: normal;\n}\n\n.migrationPreview .actionsCell {\n  justify-content: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `Ms_Ggi`,
	"headerRow": `sdnzDp`,
	"orderRow": `k8XcVc`,
	"headerCell": `ynmXnh`,
	"rowsList": `sdS96m`,
	"orderDetailsButton": `tuBOlh`,
	"cell": `qZWu6X`,
	"identification": `QHQZvj`,
	"amount": `uvdpn1`,
	"actionsCell": `KzP9j_`,
	"creditDateCell": `fAZycL`,
	"editCreditDateButton": `UC809y`,
	"creditDateCalendar": `bxfUdA`,
	"loadingContainer": `GMc9iX`,
	"loadingText": `lYQRTi`,
	"migrationPreview": `TdhFSk`
};
module.exports = ___CSS_LOADER_EXPORT___;
